@if (isAuditVisible) {
  <div class="modal-overlay">
    <div #modalRef class="modal-container" [style.left.px]="positionX" [style.top.px]="positionY">
      <!-- HEADER -->
      <div class="modal-header" (mousedown)="startDrag($event)">
        <h5 class="modal-title">{{ title }}</h5>
        <div class="d-flex justify-content-center align-items-center gap-3 actionColumn">
          <button type="button" class="btn btn-link p-0 dangerIcon iconCSS" (click)="close()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="#000"
              stroke-width="2.4"
              stroke-linecap="round"
            >
              <title>Close Audit</title>
              <path d="M6 6L18 18" />
              <path d="M18 6L6 18" />
            </svg>
          </button>
        </div>
      </div>

      <!-- BODY: Audit Trail Records -->
      <div class="modal-body">
        @if (!paginatedData || paginatedData.length === 0) {
          <h2 class="noRecordError mt-15">No records found.</h2>
        } @else {
          <div class="table-wrapper">
            <table class="table table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  @for (column of columns; track column) {
                    <th>
                      <h3 class="mb-0">{{ column }}</h3>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of paginatedData; track $index) {
                  <tr>
                    @for (column of columns; track column) {
                      <td>
                        @if (isArray(getCellValue(row, column))) {
                          @for (value of getCellValue(row, column); track $index) {
                            <div class="multi-line-cell">
                              {{ value || ' ' }}
                            </div>
                          }
                        } @else {
                          <div>
                            {{ getCellValue(row, column) }}
                          </div>
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- PAGINATION -->
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageSize"
            [totalRecords]="totalRecords"
            [pageSizeOptions]="pageSizeOptions"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"
          >
          </app-pagination>
        }
      </div>
    </div>
  </div>
}
